/** @jsx jsx */
// eslint-disable-next-line no-unused-vars
import React from 'react';
import { css, jsx } from '@emotion/react';

/**
 * Widget for rendering showing a big number and label
 *
 * @param data
 * @param widgetConfiguration
 * @returns react stuff
 * @constructor
 */
export function Metrics({ data, widgetConfiguration = {} }) {
	const { showFull = false } = widgetConfiguration;

	// currently hacked just to use the results of the facets call
	return (
		<div css={mainStyle}>
			{data.map((entry) => {
				const fullCount = entry[1].fullSize;
				const nonZeroCount = entry[1].entries.filter((e) => e.count > 0).length;
				if (showFull && fullCount !== nonZeroCount) {
					return (
						<div cy-test='metrics-data' css={entryStyle} key={entry[0]}>
							<div className="value">
								<span>{nonZeroCount}</span>
								<span className="full">{`/${fullCount}`}</span>
							</div>
							<div className="label">{entry[0]} Count</div>
						</div>
					);
				}
				return (
					<div cy-test='metrics-data' css={entryStyle} key={entry[0]}>
						<div className="value">{nonZeroCount}</div>
						<div className="label">{entry[0]} Count</div>
					</div>
				);
			})}
		</div>
	);
}

const mainStyle = css`
	display: flex;
	flex-flow: row wrap;
	justify-content: space-around;
	width: 100%;
	height: 100%;
`;

const entryStyle = css`
	flex: 0 0 auto;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: 2rem;

	.value {
		font-size: 4rem;
		line-height: 1.2;
		font-family: 'Georgia', serif;

		.full {
			font-size: 1rem;
			font-weight: 100;
		}
	}

	.label {
		font-size: 1rem;
	}
`;
